import { request } from '@wix/da-shared-react/pkg/xhr';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { API_BASE_PATH } from '../../constants';
import {
  updateCoverDeviation,
  deleteCoverDeviation,
  updateCoverDeviationOffsetY,
  UpdateCoverDeviationPayload,
  UpdateCoverDeviationOffsetYPayload,
} from '../actions/deviations';
import { runModuleInitActions } from '../sagas/modules';

import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { getModuleIdByModuleType, getModuleData } from '../selectors/modules';
import { ModuleType } from '../../types/modules';
import { Action } from 'redux-actions';
import { SagaIterator } from 'redux-saga';
import { DeleteDeviationPayload } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';

function* save(data) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/cover_deviation/save`,
    data,
  });
}

export function* updateCoverDeviationSaga(
  action: Action<UpdateCoverDeviationPayload> | Action<DeleteDeviationPayload>
): SagaIterator {
  const { payload } = action;

  let deviationId = 0;
  let entities = {};

  if (payload && payload.deviation) {
    const normalized = normalize(payload.deviation, deviationSchema);
    deviationId = normalized.result;
    entities = normalized.entities;
  }

  const moduleId = yield select(
    getModuleIdByModuleType,
    ModuleType.COVER_DEVIATION
  );

  // DeleteDeviationPayload does not have version
  const version = 'version' in payload ? payload.version : undefined;

  const response = yield call(save, {
    moduleid: moduleId,
    // Even though this expects a number and we're passing through the normalized
    // deviation id (which could be number | string), it should only ever receive
    // a deviation that production an id of type number
    deviationid: deviationId,
    version,
  });

  if (response && response.moduleData) {
    yield put(putEntities({ entities }));
    yield call(runModuleInitActions, response);
  }
}

export function* updateCoverDeviationOffsetYSaga(
  action: Action<UpdateCoverDeviationOffsetYPayload>
): SagaIterator {
  const { payload } = action;
  if (!payload) {
    return;
  }
  const moduleId = yield select(
    getModuleIdByModuleType,
    ModuleType.COVER_DEVIATION
  );
  const moduleData = yield select(getModuleData, moduleId);

  // DeleteDeviationPayload does not have version
  const version = 'version' in payload ? payload.version : undefined;

  const response = yield call(save, {
    moduleid: moduleId,
    deviationid: moduleData.coverDeviationId,
    cover_deviationid_offset_y: payload.offsetY,
    version,
  });

  if (response && response.moduleData) {
    yield call(runModuleInitActions, response);
  }
}

export default function* rootCoverDeviationSaga() {
  yield all([
    takeEvery(updateCoverDeviation, updateCoverDeviationSaga),
    takeEvery(updateCoverDeviationOffsetY, updateCoverDeviationOffsetYSaga),
    takeEvery(deleteCoverDeviation, updateCoverDeviationSaga),
  ]);
}
